import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/yoto-logo.png")